import {
  SHOW_NOTIFICATION,
  CLEAR_NOTIFICATION
} from './../constants/actionTypes'

export const showNotification = data => dispatch => {
  dispatch({
    type: SHOW_NOTIFICATION,
    data
  })
}

export const clearNotification = () => dispatch => {
  dispatch({
    type: CLEAR_NOTIFICATION
  })
}
